export const Footer = () => (
    <div className="flex bg-black p-3 text-white">
        <div className="grow" />
        <div className="px-2">
            <a href="https://github.com/cjs8487/ceejus">Source Code</a>
        </div>
    </div>
);
